module.exports = __webpack_public_path__ + "static/media/delete.abb8a771.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/delete.svg
// module id = 389
// module chunks = 33